import type { ReactElement } from 'react';
import { useCallback } from 'react';

import { captureEvent } from '@/services/analytics';

import { useTitleObserver } from '@/shared/hooks/useTitleObserver';

export function PostHogTrackingListener({ children }: { readonly children: ReactElement }) {
  const handleTitleMutation = useCallback((title: string, url: string) => {
    captureEvent('$pageview', {
      $current_url: url,
      $title: title
    });
  }, []);

  useTitleObserver(handleTitleMutation);

  return children;
}
